import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const FloatingBookingButton = () => {
  return (
    <a
      href="https://SOPHROLOGIETREETBIENTRE.as.me/"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50"
    >
      <Button
        size="lg"
        className="gap-2 shadow-lg hover:shadow-xl transition-shadow rounded-full px-6"
      >
        <Calendar className="w-5 h-5" />
        Prendre RDV
      </Button>
    </a>
  );
};

export default FloatingBookingButton;
